import Link from 'next/link';

/**
 * PublicFooter - Shared footer for all public static pages
 * Links to Contact, Terms & Conditions, and FAQs
 */
export function PublicFooter() {
  return (
    <footer className="border-t py-6">
      <div className="text-muted-foreground container mx-auto flex flex-wrap items-center justify-center gap-4 text-sm">
        <Link href="/contact" className="hover:underline">
          CONTACT US
        </Link>
        <Link href="/terms-eligibility" className="hover:underline">
          PROGRAM TERMS AND CONDITIONS
        </Link>
        <Link href="/resources/faqs" className="hover:underline">
          FREQUENTLY ASKED QUESTIONS
        </Link>
      </div>
    </footer>
  );
}
